var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 78.1663H24.5V79.1663V86.4997H14V50.1683L23.8364 21.833H77.2043L87 50.1677V86.4997H76.5V79.1663V78.1663H75.5H25.5ZM20.3846 45.5168L19.9459 46.833H21.3333H79.6667H81.0541L80.6153 45.5168L74.3653 26.7668L74.1374 26.083H73.4167H27.5833H26.8626L26.6346 26.7668L20.3846 45.5168ZM20.3333 60.4163C20.3333 64.427 23.5727 67.6663 27.5833 67.6663C31.594 67.6663 34.8333 64.427 34.8333 60.4163C34.8333 56.4057 31.594 53.1663 27.5833 53.1663C23.5727 53.1663 20.3333 56.4057 20.3333 60.4163ZM66.1667 60.4163C66.1667 64.427 69.406 67.6663 73.4167 67.6663C77.4273 67.6663 80.6667 64.427 80.6667 60.4163C80.6667 56.4057 77.4273 53.1663 73.4167 53.1663C69.406 53.1663 66.1667 56.4057 66.1667 60.4163Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/Car.82a4692fbdd612cc5bb35348917cd902.svg";
export { ForwardRef as ReactComponent };